import React from 'react';
import { Box, Paper } from '@material-ui/core';
import {AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const CustomizedAxisTick = ({ x, y, payload }) =>{
  const parts = payload.value.split(' ');
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-35)">{parts[0]}</text>
      <text x={0} y={16} dy={16} textAnchor="end" fill="#666" transform="rotate(-35)">{parts[1]}</text>
    </g>
  );
}

const Graph = ({ type, items }) => {
  return (
    // <Paper >
      <Box height={600} width='100%'>
        <ResponsiveContainer className="ResponsiveContainer">
          <AreaChart
          //  width={500}
          width ="100%"
        height={400}
         data={items}
         margin={{
          top: 20, right: 30, left: 20, bottom: 20,
        }}
        
        >
            <XAxis dataKey="fixTime" tick={<CustomizedAxisTick/>}  />
            <YAxis />
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip />
            
            <Area type="monotone" dataKey={type} stroke="#197509" fill="#197509" />
            <Legend />
          </AreaChart>
        </ResponsiveContainer>
      </Box>
    // </Paper>
  );
}

export default Graph;
